import { createUseStyles } from 'react-jss';

export const useWalletIconStyle = createUseStyles({
    root: {
        width: 36,
        height: 36,
    },
});
